import { OverlayTrigger, Popover } from 'react-bootstrap';

type PopoverLinkProps = {
    lastErrorMessage: string;
    linkText: string;
};

const PopoverLink: React.FC<PopoverLinkProps> = ({ lastErrorMessage, linkText }) => {
    const popover = (
        <Popover id="popover-error" className="custom-popover">
            <Popover.Body>
                {lastErrorMessage || 'No error message available.'}
            </Popover.Body>
        </Popover>
    );

    return (
        <span>
      <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          overlay={popover}
          containerPadding={10}
      >
        <a className="ms-2" role="button" tabIndex={0}>
          {linkText}
        </a>
      </OverlayTrigger>
    </span>
    );
};

export default PopoverLink;
